import {
  AlertTitle,
  AlertDescription,
  Box,
  Alert,
  CloseButton,
  Text,
  AlertIcon,
  Link as ChakraLink,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../app/typedReduxHooks'
import { useHasPermission } from '../../../hooks/useHasPermission'
import { RootState } from '../../../app/store'
import { format } from 'date-fns'
import { setHasSentLowTokenNotification } from '../BillingSlice'
import { routes } from '../../routes'
import { Permission } from '../../../types/permission'

export const LowRemainingTokensNotificationContent = () => {
  const {
    data: billingData,
    warning,
    hasSentLowTokenNotification,
  } = useAppSelector((state: RootState) => state.billing?.subscription)
  const dispatch = useAppDispatch()

  const hasBillingManagementPermission = useHasPermission(Permission.BILLING_MANAGEMENT, {
    includeOwnerSuperAdminFallback: true,
  })
  const isAbleToManageBilling = billingData?.stripeSubscriptionId && hasBillingManagementPermission

  const handleClose = () => {
    dispatch(setHasSentLowTokenNotification(true))
  }

  return !hasSentLowTokenNotification && warning?.code ? (
    <Alert status="warning" variant="left-accent">
      <AlertIcon />
      <Box flex={1}>
        <AlertTitle>Low Remaining Tokens</AlertTitle>
        <AlertDescription>
          <Text>
            You only have{' '}
            <Text as="span" fontWeight="bold">
              {billingData?.remainingTokens}
            </Text>{' '}
            more prescriptions left until{' '}
            <Text as="span" fontWeight="bold">
              {billingData?.currentPeriodEnd &&
                format(new Date(billingData.currentPeriodEnd), 'dd/MM/yyyy')}
            </Text>
            .{' '}
            {hasBillingManagementPermission ? (
              <>
                {isAbleToManageBilling ? (
                  <>
                    <Link to="/settings?tab=subscription" style={{ color: 'dodgerblue' }}>
                      Upgrade
                    </Link>{' '}
                    your subscription now to avoid interruptions.
                  </>
                ) : (
                  <>
                    <ChakraLink href="mailto:support@rxpad.com.au" style={{ color: 'dodgerblue' }}>
                      Contact us
                    </ChakraLink>{' '}
                    to upgrade your subscription.
                  </>
                )}
              </>
            ) : (
              <>
                Contact your organisation owner now to upgrade to unlimited. Click{' '}
                <Link to={`${routes.settings.path}?tab=users`} style={{ color: 'dodgerblue' }}>
                  here
                </Link>{' '}
                to check organisation owner.
              </>
            )}
          </Text>
        </AlertDescription>
      </Box>
      <CloseButton
        alignSelf="flex-start"
        position="relative"
        right={-1}
        top={-1}
        onClick={handleClose}
      />
    </Alert>
  ) : null
}
